import { Box, Button, Divider, FormLabel, Grid, IconButton, Input, Modal, SelectChangeEvent, Stack, Switch, Typography } from "@mui/material";
import { SelectMinisterio } from "../../../../components/selects/ministerio";
import { SelectFrequencia } from "../../../../components/selects/frequencia";
import { SelectSede } from "../../../../components/selects/sede";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { ServicesCadastrar as useServices } from "./services";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import InputCep from "../../../../components/inputs/cepInput";

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '12px',
  boxShadow: 24,
  p: 2,
};

export default function AddCelula() {

  const { cadastrarCelula, celulaSelecionada, changeCampusCelula } = useServices();

  const router = useNavigate();

  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    router(-1);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography id="modal-modal-title" variant="h5" component="h2">
              PG’s
            </Typography>
            <IconButton aria-label="fechar" size="medium" onClick={handleClose}>
              <CloseRoundedIcon fontSize="inherit" />
            </IconButton>
          </div>
          <Divider />
          <Grid display={'grid'} gap={'8px'} mt={1} gridTemplateColumns={{ lg: 'repeat(2, 1fr)' }}>
            <Grid item display={'grid'}>
              <SelectSede
                value={celulaSelecionada?.sede || ''}
                action={(value) => { changeCampusCelula('sede', value); }}
              />
            </Grid>

            <SelectMinisterio
              idsede={celulaSelecionada?.sede || ''}
              valor={celulaSelecionada?.ministerio}
              action={(value: SelectChangeEvent) => { changeCampusCelula('ministerio', value?.target?.value); }}
            />

            <Grid item display={'grid'}>
              <FormLabel>Nome</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('descricao', String(value?.target?.value))}
                value={celulaSelecionada?.descricao || ''}
              />
            </Grid>

            <Grid item display={'grid'}>
              <InputCep
                onChange={(value) => changeCampusCelula('cep', value)}
                value={celulaSelecionada?.cep}
              />
            </Grid>

            <Grid item display={'grid'}>
              <FormLabel>Altitude</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('latitude', String(value?.target?.value)?.trim())}
                value={celulaSelecionada?.latitude || ''}

              />
            </Grid>

            <Grid item display={'grid'}>
              <FormLabel>longitude</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('longitude', String(value?.target?.value)?.trim())}
                value={celulaSelecionada?.longitude || ''}
              />
            </Grid>

            <Grid item display={'grid'}>
              <FormLabel>Bairro</FormLabel>
              <Input
                onChange={(value) => changeCampusCelula('bairro', String(value?.target?.value))}
                value={celulaSelecionada?.bairro || ''}
              />
            </Grid>

            <Grid item display={'grid'}>
              <FormLabel>Endereço</FormLabel>
              <Input
                value={celulaSelecionada?.endereco || ''}
                onChange={(value) => changeCampusCelula('endereco', String(value?.target?.value))}
              />
            </Grid>
            <Grid item display={'grid'}>
              <FormLabel>Horário</FormLabel>
              <Input
                type="time"
                onChange={(value) => {
                  const horaMinuto = value?.target?.value; 
                  const horaFormatada = horaMinuto ? `${horaMinuto}:00` : ''; 
                  changeCampusCelula('horario', horaFormatada);
                }}
                value={(celulaSelecionada?.horario || '').substring(0, 5)} 
              />
            </Grid>

            <SelectFrequencia
              action={(value: SelectChangeEvent) => changeCampusCelula('frequencia', value?.target?.value)}
              valor={celulaSelecionada?.frequencia || ''}
            />
          </Grid>
          <Stack mt={2} direction={'row'} justifyContent={'space-between'}>
            <Button color="error">Cancelar</Button>
            <Button onClick={cadastrarCelula}>Criar</Button>
          </Stack>
        </Box>
      </Modal>
    </>
  )
}
